import { render, staticRenderFns } from "./TechBackground.vue?vue&type=template&id=4a100d45&scoped=true"
import script from "./TechBackground.vue?vue&type=script&lang=js"
export * from "./TechBackground.vue?vue&type=script&lang=js"
import style0 from "./TechBackground.vue?vue&type=style&index=0&id=4a100d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a100d45",
  null
  
)

export default component.exports